import React, {useState} from "react";
import Popup from "reactjs-popup";
import "reactjs-popup/dist/index.css";
import Styles from "./styles.module.scss";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import {
    changePassword,
    changePasswordFailure,
    setSettingsChangePasswordModalStatus
} from "../../../store/cabinet/action";
// import {toast} from "react-toastify";

const CabinetSettingsChangePasswordModal = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const settingsChangePasswordModalStatus = useSelector(store => store.cabinet.settingsChangePasswordModalStatus);
    const formErr = useSelector(store => store.cabinet.changePasswordStatusErr);
    const changePasswordStatusStarted = useSelector(store => store.cabinet.changePasswordStatusStarted);


    const [current_password, setCurrentPassword] = useState('');
    const [password , setPassword] = useState('');
    const [password_confirmation, setPasswordConfirmation] = useState('');

    const closeModal = () => {
        setCurrentPassword('');
        setPasswordConfirmation('');
        setPassword('');
        dispatch(setSettingsChangePasswordModalStatus(false));
    };

    const isSubmitSuccess = () =>{
        return !changePasswordStatusStarted
    }

    const successHandler = () =>{
        // toast(t('Ваш пароль успешно изменен!'));
        closeModal();
    }

    const sendFormHandler = () =>{
        if (isSubmitSuccess()) {
            dispatch(changePassword({current_password, password_confirmation, password}, successHandler));
        }
    }

    return (
        <Popup
            open={settingsChangePasswordModalStatus}
            modal
            nested
            closeOnDocumentClick
            onClose={closeModal}
        >
            <div className={Styles.modalContainer}>
                <div className={Styles.modalCloseBtn} onClick={closeModal}>
                    <div />
                    <div />
                </div>

                <div className={Styles.modalContentWrap}>
                    <div className={Styles.modalTitle}>
                        {t("Изменить пароль")}
                    </div>

                    <div className={Styles.inputWrap}>
                        <div className={`${Styles.inputBox} ${formErr?.current_password ? Styles.inputWrapWithErr : null}`}>
                            <div className={Styles.inputBoxTitle}>{t('Введите ваш старый пароль')}</div>
                            <input
                                className={`${Styles.tcInput}`}
                                type="password"
                                placeholder="••••••••"
                                value={current_password}
                                onChange={(e)=>{setCurrentPassword(e.target.value)}}
                                onKeyDown={(event)=>{
                                    if (formErr.current_password){
                                        delete formErr.current_password;
                                        dispatch(changePasswordFailure(formErr));
                                    }
                                }}
                            />
                            <div className={`${Styles.tcErr} ${formErr?.current_password ? Styles.tcErrActive : null}`}>{formErr?.current_password ? formErr.current_password : null}</div>
                        </div>
                        <div className={`${Styles.inputBox} ${formErr?.password ? Styles.inputWrapWithErr : null}`}>
                            <div className={Styles.inputBoxTitle}>{t('Введите новый пароль')}</div>
                            <input
                                className={`${Styles.tcInput}`}
                                type="password"
                                placeholder="••••••••"
                                value={password}
                                onChange={(e)=>{setPassword(e.target.value)}}
                                onKeyDown={(event)=>{
                                    if (formErr.password){
                                        delete formErr.password;
                                        dispatch(changePasswordFailure(formErr));
                                    }
                                }}
                            />
                            <div className={`${Styles.tcErr} ${formErr?.password ? Styles.tcErrActive : null}`}>{formErr?.password ? formErr.password : null}</div>
                        </div>
                        <div className={`${Styles.inputBox} ${formErr?.password_confirmation ? Styles.inputWrapWithErr : null}`}>
                            <div className={Styles.inputBoxTitle}>{t('Повторите новый пароль')}</div>
                            <input
                                className={`${Styles.tcInput}`}
                                type="password"
                                placeholder="••••••••"
                                value={password_confirmation}
                                onChange={(e)=>{setPasswordConfirmation(e.target.value)}}
                                onKeyDown={(event)=>{
                                    if (formErr.password_confirmation){
                                        delete formErr.password_confirmation;
                                        dispatch(changePasswordFailure(formErr));
                                    }
                                }}
                            />
                            <div className={`${Styles.tcErr} ${formErr?.password_confirmation ? Styles.tcErrActive : null}`}>{formErr?.password_confirmation ? formErr.password_confirmation : null}</div>
                        </div>
                    </div>

                    <div className={`${Styles.tcBtn}`} onClick={()=>{sendFormHandler()}}>{t('Сохранить')}</div>
                </div>
            </div>
        </Popup>
    );
};

export default CabinetSettingsChangePasswordModal;
